
class AccordionSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const accordions = this.querySelector(".accordion-section");


      this.toggleBtn = this.querySelector(".accordion-toggle");
      this.content = this.querySelector(".accordion-section__content");

      if (!this.toggleBtn || !this.content) return;

      this.toggleBtn.addEventListener("click", () => this.toggleAccordion());

      // if (toggleBtn && content) {
      //   toggleBtn.addEventListener("click", () => {
      //     debugger
      //     const expanded = toggleBtn.getAttribute("aria-expanded") === "true";
      //     toggleBtn.setAttribute("aria-expanded", String(!expanded));
      //     toggleBtn.textContent = expanded ? "+ Learn More" : "- Hide";
      //     content.hidden = expanded;
      //   });
      // }

  }

  toggleAccordion() {
    const expanded = this.toggleBtn.getAttribute("aria-expanded") === "true";
    this.toggleBtn.setAttribute("aria-expanded", String(!expanded));
    this.toggleBtn.textContent = expanded ? "+ Learn More" : "- Hide";
    this.content.hidden = expanded;
  }
}

customElements.define("accordion-section", AccordionSection);

